interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc: string;
  id?: string;
}

export default function SectionHeading({ kicker, title, desc, id }: SectionHeadingProps) {
  return (
    <div id={id} data-reveal className="max-w-3xl scroll-mt-24 md:scroll-mt-28">
      <div className="flex items-center gap-3">
        <span className="font-display text-xl leading-none text-accent-600">{kicker}</span>
        <span className="h-px w-16 bg-foreground-300" />
      </div>
      <h2 className="mt-4 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
        {title}
      </h2>
      <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
        {desc}
      </p>
    </div>
  );
}